import BillingsOrderRelatedTaxiDriverResponse, {
  BillingsOrderRelatedTaxiDriverResponseData,
  BillingsOrderRelatedTaxiDriverResponseDataContract,
  BillingsOrderRelatedTaxiDriverResponseDataContractBillingModel,
} from "../../../../../api/raily/billings/order/related/taxi-driver/billings-order-related-taxi-driver.response";
import BillingModel from "../../../../../types/billing-model";
import BillingsOrderRelatedTaxiDriver, {
  BillingsOrderRelatedTaxiDriverData,
  BillingsOrderRelatedTaxiDriverDataContractDetails,
} from "./billings-order-related-taxi-driver";

const createDataItemBillingModel = (
  billingModel: BillingsOrderRelatedTaxiDriverResponseDataContractBillingModel,
): BillingModel => {
  switch (billingModel) {
    case BillingsOrderRelatedTaxiDriverResponseDataContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsOrderRelatedTaxiDriverResponseDataContractBillingModel.SABS:
      return BillingModel.SABS;
    case BillingsOrderRelatedTaxiDriverResponseDataContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsOrderRelatedTaxiDriverResponseDataContractBillingModel.OTHER:
      return BillingModel.OTHER;
  }
};

const createDataItemContractDetails = (
  contractDetails: BillingsOrderRelatedTaxiDriverResponseDataContract,
): BillingsOrderRelatedTaxiDriverDataContractDetails => {
  return {
    companyName:
      contractDetails.taxiDriverAssociation.taxiCorporation.displayName,
    distanceRate: contractDetails.distanceRate,
    model: createDataItemBillingModel(contractDetails.model),
  };
};

const createDataItem = (
  data: BillingsOrderRelatedTaxiDriverResponseData,
): BillingsOrderRelatedTaxiDriverData => {
  return {
    billingUuid: data.id,
    contractDetails: createDataItemContractDetails(data.contract),
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    distance: data.distance,
    amountForDistance: data.amountForDistance,
    internalOrderId: data.planEntry.humanId,
    allContributionsAmount: data.allContributionsAmount,
    isDraft: data.draft,
    date: data.date,
    sumOfBonuses: data.sumOfBonuses,
    sumOfPenalties: data.sumOfPenalties,
  };
};

const createData = (
  responseData: BillingsOrderRelatedTaxiDriverResponseData[],
): BillingsOrderRelatedTaxiDriverData[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: BillingsOrderRelatedTaxiDriverResponse,
): BillingsOrderRelatedTaxiDriver => {
  return {
    data: createData(response.data),
  };
};

const billingsOrderRelatedTaxiDriverFactory = {
  create,
};

export default billingsOrderRelatedTaxiDriverFactory;
